export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empaques"])},
          "new_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar empaques"])},
          "packages_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generar packing list"])},
          "edit_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Packages"])},
          "new_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create packages"])}
        }
      }
    }
  })
}